module.exports = __webpack_public_path__ + "img/close-ac.6302bd8b.svg";